import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, reactive} from "vue";
import SogForm from "@/shared/ui/SogForm.vue";
import sogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";

interface Props {
  //currentView?: string,
  nextInvoiceDate?: Date,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogScheduleSerie',
  props: {
    nextInvoiceDate: { default: undefined }
  },
  setup(__props: any) {

const _schedule = ref<InstanceType<typeof sogForm> | null>(null)
const _currentView = ref<string>("Day")
const _selectedDate = ref(new Date().toLocaleTimeString())
const _lstViews = reactive([
  {
    id: "Day",
    value: "täglich"
  },
  {
    id: "Week",
    value: "wöchentlich",
  },
]);

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_schedule",
    ref: _schedule
  }, {
    default: _withCtx(() => [
      _createVNode(SogFlexRow, null, {
        default: _withCtx(() => [
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogDropDownList, {
                modelValue: _currentView.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_currentView).value = $event)),
                "data-source": _lstViews
              }, null, 8, ["modelValue", "data-source"])
            ]),
            _: 1
          }),
          _createVNode(SogFormField, null, {
            default: _withCtx(() => [
              _createVNode(SogTextBox, {
                modelValue: _selectedDate.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_selectedDate).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})